<template>
  <div class="w-full">
    <div class="w-full DashboardContainer"></div>

    <div class="mt-6 bg-white p-4 sm:p-6 sm:pb-4 rounded-md shadow-sm">
      <div class="sm:flex sm:flex-col sm:items-start">
        <div class="mb-2 w-full">
          <!-- Warning Message -->
          <div class="rounded-md bg-yellow-50 p-4 mb-4">
            <div class="flex">
              <div class="ml-3 flex-1 md:flex md:justify-between">
                <p class="text-sm text-yellow-800 text-center">
                  <strong>Notice!</strong> The video information section has
                  changed. Please take note as you fill out each of the boxes
                  below.
                </p>
              </div>
            </div>
          </div>

          <!-- Upload data grid -->
          <div class="grid grid-cols-4 gap-4">
            <div class="col-span-4 md:col-span-1">
              <label
                for="start"
                class="block text-sm font-medium text-gray-700"
              >
                Date
              </label>
              <input
                type="date"
                id="start"
                name="start"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                v-model="videoDetails.date"
              />
            </div>
            <div class="col-span-4 md:col-span-3 lg:col-span-1">
              <label
                for="video_location"
                class="block text-sm font-medium text-gray-700 flex flex-row justify-between items-center"
                >Location
                <span class="text-xs font-normal text-gray-400"
                  >City, ST</span
                ></label
              >
              <input
                type="text"
                name="video_location"
                id="video_location"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                v-model="videoDetails.preciseLocation"
              />
            </div>
            <div class="col-span-4 lg:col-span-2">
              <label
                for="video_title"
                class="block text-sm font-medium text-gray-700 flex flex-row justify-between items-center"
                >Event
                <span class="text-xs font-normal text-gray-400"
                  >{{ videoDetails.title | count }} characters remaining</span
                ></label
              >
              <input
                type="text"
                name="video_title"
                id="video_title"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                v-model="videoDetails.event"
              />
            </div>
            <div class="col-span-4 text-xs text-gray-500 -mt-2">
              Formatted title: {{ videoDetails.title }}
            </div>
            <div class="col-span-4">
              <label
                for="video_description"
                class="block text-sm font-medium text-gray-700"
                >Narrative</label
              >
              <textarea
                id="video_description"
                name="video_description"
                rows="10"
                class="shadow-sm focus:ring-blue-500 focus:border-blue-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                v-model="videoDetails.description"
              ></textarea>
            </div>
            <div class="col-span-4">
              <label
                for="locations"
                class="block text-sm font-medium text-gray-700"
                >Filming Locations</label
              >
              <div
                class="-mx-1 py-1"
                v-if="videoDetails.locationsFromSearch.length > 0"
              >
                <span
                  class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm bg-blue-100 text-blue-700 m-1"
                  v-for="(location, key) in videoDetails.locationsFromSearch"
                  v-bind:key="key"
                >
                  {{ location.text }}
                  <button
                    type="button"
                    class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-blue-400 hover:bg-blue-200 hover:text-blue-500 focus:outline-none focus:bg-blue-500 focus:text-white"
                    v-on:click="removeLocation(key)"
                  >
                    <span class="sr-only">Remove large option</span>
                    <svg
                      class="h-2 w-2"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 8 8"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-width="1.5"
                        d="M1 1l6 6m0-6L1 7"
                      />
                    </svg>
                  </button>
                </span>
              </div>
              <SearchListBox
                :dataArr="locationSearch"
                placeholder="Type to search for a location..."
                resId="locations"
                textKey="text"
                @onSearch="onSearch"
                @onSelect="onSelectItem"
              />
            </div>
            <div class="col-span-4">
              <label
                for="tags"
                class="block text-sm font-medium text-gray-700 flex flex-row justify-between items-center"
                >Tags</label
              >
              <TagInput resId="tags" :tags="videoDetails.tags" />
            </div>

            <div class="col-span-4 md:col-span-2">
              <label class="block text-sm font-medium text-gray-700">
                Video Type
              </label>
              <!-- <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="videoDetails.title"> -->
              <select
                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                v-model="videoDetails.type"
              >
                <option value="eng">B-Roll (ENG)</option>
                <option value="stock">Stock</option>
              </select>
            </div>

            <div class="col-span-4 md:col-span-2">
              <label class="block text-sm font-medium text-gray-700">
                Contains any drone footage?
              </label>
              <!-- <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="inline-full-name" type="text" v-model="videoDetails.title"> -->
              <select
                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                v-model="videoDetails.isDrone"
              >
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>

            <div
              class="col-span-4 flex flex-row space-x-4 items-center"
              v-if="videoDetails.isDrone"
            >
              <input
                name="droneVerification"
                id="droneVerification"
                type="checkbox"
                class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none"
                v-model="videoDetails.droneVerification"
              />
              <label for="droneVerification" class="sm:text-sm">
                By checking this box, you are signifying that all state/local
                laws and FAA regulations were followed, and that you hold a
                current Part 107 Airman certificate as well as any applicable
                waivers (§107.25, §107.29, §107.31, §107.33, §107.35,
                §107.37(a), §107.39, §107.51).
              </label>
            </div>
          </div>
        </div>
        <div
          class="w-full flex flex-col md:flex-row justify-between items-center mt-8 mb-2"
        >
          <p
            class="text-gray-500 text-sm hidden md:block"
            v-if="videoDetails.upload_id == null"
          >
            You must start your upload before you can save your changes.
          </p>
          <button
            class="text-white rounded px-4 py-2 focus:outline-none"
            :class="{
              'bg-blue-600 hover:bg-blue-700': videoDetails.id !== null,
              'cursor-not-allowed bg-blue-400': videoDetails.id == null
            }"
            v-on:click="updateVideoDetails"
            :disabled="videoDetails.id == null"
          >
            Update Video Details
          </button>
          <p
            class="text-gray-500 text-sm block md:hidden mt-4"
            v-if="videoDetails.upload_id == null"
          >
            You must start your upload before you can save your changes.
          </p>
        </div>
      </div>
    </div>

    <div class="w-full text-center mt-8"></div>
  </div>
</template>

<script>
/* eslint-disable */
import * as Config from "@/config";
import { mapGetters } from "vuex";
var tus = require("tus-js-client");

import axios from "axios";
import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import GoogleDrive from "@uppy/google-drive";
import Dropbox from "@uppy/dropbox";
import Tus from "@uppy/tus";
import moment from "moment";

import SearchListBox from "@/components/SearchListBox";
import TagInput from "@/components/TagInput";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

export default {
  name: "HelloWorld",
  data() {
    return {
      tus: tus,
      uploadDetails: {
        server: "upload-v2.cdn",
        startTime: null,
        endTime: null,
        elapsedSeconds: 0,
        bytesUploaded: 0,
        bytesTotal: 0,
        fileProgress: 0,
        uploadingComplete: false,
        uploadStarted: false,
        uploadPaused: false
      },
      videoDetails: {
        id: null,

        // NEW
        date: moment().format("YYYY-MM-DD"),
        preciseLocation: null,
        event: null,

        title: null,
        description: null,
        locations: [],
        magicKeys: [],
        locationsFromSearch: [],
        tags: [],
        coordinates: [],

        upload_id: null,
        upload_filename: null,

        status: "upload_progress",
        progress: 0,

        type: "eng",

        category: null,
        breakdown: null,

        droneVerification: false,
        isDrone: false
      },
      servers: {},
      categories: [],
      breakdowns: [],

      uploading: false,
      failed: false,
      file: null,
      allowUpdatesToBackend: false,

      locationSearch: [],
      locationData: null,

      uppy: null
    };
  },
  components: {
    TagInput,
    SearchListBox
  },
  mounted() {
    setInterval(
      function() {
        if (this.uploading == true) {
          this.updateProgress();
        }
      }.bind(this),
      5000
    );

    this.uppy = Uppy({
      debug: true,
      autoProceed: false,
      restrictions: {
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ["video/*"]
      }
    })
      .use(Dashboard, {
        trigger: ".UppyModalOpenerBtn",
        inline: true,
        target: ".DashboardContainer",
        replaceTargetContent: true,
        showProgressDetails: true,
        note: "One video file only.",
        height: 400,
        width: "100%",
        browserBackButtonClose: true
      })
      .use(GoogleDrive, {
        target: Dashboard,
        companionUrl: "https://cdn-uc.livestormsvideo.com"
      })
      .use(Dropbox, {
        target: Dashboard,
        companionUrl: "https://cdn-uc.livestormsvideo.com"
      })
      .use(Tus, {
        endpoint: "https://upload-v2.cdn.livestormsvideo.com/files/",
        resume: true,
        removeFingerprintOnSuccess: true // could prevent issue where if user uploads file again it over writes existing entry in db
      });

    this.uppy.on("complete", result => {
      if (result.successful.length > 0) {
        var url = result.successful[0].uploadURL;
        var file = result.successful[0].data.name;
        this.videoDetails.upload_id = url.split("/")[4];
        this.videoDetails.upload_filename =
          this.videoDetails.upload_id + "." + file.split(".").pop();
        this.finalizeUpload();
      }

      if (result.failed.length > 0) {
        this.uploadError();
      }
    });

    this.uppy.on("upload", data => {
      console.log(data);
      this.videoDetails.status = "uploading";
      this.initializeVideoUpload();
    });

    this.uppy.on("file-added", file => {
      if (this.videoDetails.title == null) {
        this.videoDetails.title = file.name;
      }
    });

    this.uppy.on("upload-progress", (file, progress) => {
      this.videoDetails.progress = (
        (progress.bytesUploaded / progress.bytesTotal) *
        100
      ).toFixed(2);
    });

    this.uppy.on("back-online", () => {
      this.uppy.retryAll();
    });
  },
  beforeRouteLeave(route, redirect, next) {
    if (this.videoDetails.status == "uploading") {
      this.$swal({
        title: "Continue?",
        text:
          "Your upload has not completed yet. Leaving this page will cancel your upload.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, leave page."
      }).then(result => {
        if (result.value) {
          next();
        } else {
          return;
        }
      });
    } else {
      next();
    }
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),

    fileInputChange() {
      this.file = document.getElementById("video").files[0];
      this.setupFileUpload();
    },

    setupFileUpload() {
      this.uploading = true;
      this.failed = false;

      this.uploadDetails.startTime = new Date();

      this.fileUpload(this.file, {
        endpoint:
          "https://" +
          this.uploadDetails.server +
          ".livestormsvideo.com/files/",
        resume: true,

        metadata: {
          name: this.file.name,
          extension: this.file.name.split(".").pop()
        },

        removeFingerprintOnSuccess: true, // could prevent issue where if user uploads file again it over writes existing entry in db

        onError: this.onError,
        onShouldRetry: this.onShouldRetry,
        onProgress: this.onProgress,
        onSuccess: this.onSuccess
      });

      if (this.videoDetails.title == null) {
        var workingTitle = this.file.name;
        this.videoDetails.title = workingTitle.split(".")[0];
      }
    },

    onError(error) {
      console.log("Error", error);
      console.log("Request", error.originalRequest);
      console.log("Response", error.originalResponse);
    },

    onShouldRetry(error, retryAttempt, options) {
      console.log("Error", error);
      console.log("Request", error.originalRequest);
      console.log("Response", error.originalResponse);

      var status = error.originalResponse
        ? error.originalResponse.getStatus()
        : 0;
      // Do not retry if the status is a 403.
      if (status === 403) {
        return false;
      }

      // For any other status code, we retry.
      return true;
    },

    onProgress(bytesUploaded, bytesTotal) {
      console.log("progress");
      this.uploadDetails.bytesUploaded = bytesUploaded;
      this.uploadDetails.bytesTotal = bytesTotal;
      this.videoDetails.progress = ((bytesUploaded / bytesTotal) * 100).toFixed(
        2
      );

      if (this.videoDetails.upload_id == null) {
        var url = this.tusFileUploader.url;
        this.videoDetails.upload_id = url.split("/")[4];
        this.videoDetails.upload_filename =
          this.videoDetails.upload_id + "." + this.file.name.split(".").pop();
        this.initializeVideoUpload();
      }
    },

    onSuccess() {
      this.uploadDetails.uploadingComplete = true;
      this.uploading = false;
      this.finalizeUpload();
    },

    fileUpload(file, options) {
      this.tusFileUploader = new this.tus.Upload(file, options);
      this.uploadDetails.uploadStarted = true;
      this.tusFileUploader.start();

      this.videoDetails.status = "uploading";
      this.uploading = true;
    },

    abortFileUpload() {
      this.tusFileUploader.abort();
      this.uploadDetails.uploadPaused = true;
      this.videoDetails.status = "upload_paused";
      this.uploading = false;
      this.updateProgress();
    },

    resumeFileUpload() {
      this.tusFileUploader.start();
      this.uploadDetails.uploadPaused = false;
      this.videoDetails.status = "uploading";
      this.uploading = true;
      this.updateProgress();
    },

    async initializeVideoUpload() {
      var formData = this.videoDetails;

      let res = await this.$http.post(
        Config.apiPath + "/api/v2/stringer/videos/upload",
        formData,
        this.getAuthorizationHeader()
      );
      this.videoDetails.id = res.data.id;
    },

    async updateVideoDetails() {
      console.log("clicked");
      console.log(this.checkVideoTitle());
      if (this.checkVideoTitle()) {
        var formData = this.videoDetails;

        try {
          await this.$http.post(
            Config.apiPath +
              "/api/v2/stringer/videos/upload/" +
              this.videoDetails.id,
            formData,
            this.getAuthorizationHeader()
          );
          this.$swal("Updated!", "Your video has been updated.", "success");
        } catch (e) {
          console.log(e);
          this.$swal("Whoops!", "We have encountered an error.", "error");
        }
      }
    },

    async finalizeUpload() {
      this.videoDetails.status = "upload_complete";

      var formData = {
        upload_id: this.videoDetails.upload_id,
        upload_filename: this.videoDetails.upload_filename,
        magicKeys: this.videoDetails.magicKeys
      };

      try {
        await this.$http.post(
          Config.apiPath +
            "/api/v2/stringer/videos/upload/" +
            this.videoDetails.id +
            "/finalize",
          formData,
          this.getAuthorizationHeader()
        );
        this.$swal(
          "Upload complete!",
          "Your video has been uploaded.",
          "success"
        );
        this.updateVideoDetails();
      } catch (e) {
        console.log(e);
        this.$swal("Whoops!", "We have encountered an error.", "error");
      }
    },

    async updateProgress() {
      var formData = {
        upload_id: this.videoDetails.upload_id,
        progress: this.videoDetails.progress,
        status: this.videoDetails.status
      };

      await this.$http.post(
        Config.apiPath +
          "/api/v2/stringer/videos/upload/" +
          this.videoDetails.id +
          "/progress",
        formData,
        this.getAuthorizationHeader()
      );
    },

    checkVideoTitle() {
      if (this.videoDetails.title == null) {
        return false;
      }
      var title = this.videoDetails.title;
      var uppercase = title.replace(/[^A-Z]/g, "").length;
      var words = title.split(" ").length;

      // check to see if not more capital letters than words
      if (uppercase > words + 1) {
        this.$swal({
          title: "Your title is not properly formatted.",
          text: "Please check the required format under the video.",
          type: "error",
          showCancelButton: false,
          confirmButtonText: "I`ll fix it."
        });

        return false;
      }

      // check to see if tite is not greater than 100
      if (title.length > 100) {
        this.$swal({
          title: "Your title is too long!",
          text: "You cannot have more than 100 characters for a video title.",
          type: "error",
          showCancelButton: false,
          confirmButtonText: "Ok"
        });

        return false;
      }

      return true;
    },

    removeLocation(key) {
      this.videoDetails.locations.splice(key, 1);
      this.videoDetails.locationsFromSearch.splice(key, 1);
    },

    uploadError() {
      this.$swal({
        title: "Upload error",
        text: "Please try uploading again.",
        type: "error",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
    },

    async onSearch(searchText) {
      const arcgis = axios.create({
        baseURL: "https://geocode.arcgis.com"
      });
      delete arcgis.defaults.headers.common["Authorization"];
      const res = await arcgis.get(
        "/arcgis/rest/services/World/GeocodeServer/suggest?f=json&countryCode=USA%2CPRI%2CVIR%2CGUM%2CASM%2CCAN&category=Postal%2CPopulated+Place&maxSuggestions=10&text=" +
          searchText
      );
      this.locationSearch = res.data.suggestions;
    },
    async onSelectItem(item) {
      this.locationSearch = []; // clear locations
      this.videoDetails.locations.push(item.text);
      this.videoDetails.locationsFromSearch.push(item);
      this.videoDetails.magicKeys.push(item.magicKey);
    },

    updateTitle() {
      let title = "";
      var date = moment(this.videoDetails.date).format("MM-DD-YYYY");
      title += date + " ";
      if (this.videoDetails.preciseLocation)
        title += this.videoDetails.preciseLocation + " - ";
      if (this.videoDetails.event) title += this.videoDetails.event;
      this.videoDetails.title = title;
    }
  },
  watch: {
    "videoDetails.date": function() {
      this.updateTitle();
    },
    "videoDetails.preciseLocation": function() {
      this.updateTitle();
    },
    "videoDetails.event": function() {
      this.updateTitle();
    },
    "videoDetails.title": function(val) {
      console.log("title:" + val);
    }
  }
};
</script>

<style>
.uppy-Dashboard {
  z-index: 10 !important;
}
.uppy-Dashboard-inner {
  background-color: #fff;
}
::-webkit-inner-spin-button {
  height: 1em;
}
</style>
